// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#container[data-v-4e60cd18]{min-height:100vh;background-color:#f4f4f5}[data-v-4e60cd18] .el-main{padding:0;overflow-x:hidden}#inner[data-v-4e60cd18]{padding:1.5em;background-color:#f4f4f5}.el-menu.el-menu--horizontal[data-v-4e60cd18]{border:none!important}.el-menu-item.is-active[data-v-4e60cd18]{border-bottom:none!important}#type[data-v-4e60cd18]{position:fixed;right:0;bottom:0;background:var(--orange);color:#fff;padding:.5em}.custom-icon[data-v-4e60cd18]{font-size:24px}", ""]);
// Exports
module.exports = exports;
